export default class Note {
  id: number
  tags: string[] = []
  text: string = ''
  createdAt: Date

  constructor (attributes?) {
    Object.assign(this, attributes)
    if (this.createdAt) {
      this.createdAt = new Date(this.createdAt)
    }
  }
}
